import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';

import { IcDocumentStrokeIcon, IcLocationStrokeIcon } from '@gem/icons';
import { usePopover } from '@gem/ui-kit';

import Tasks from 'APP/Tasks';
import { SelectLocationPopup } from 'APP/main/PopupManager/Popups/SelectLocationPopup/SelectLocationPopup';

import { FOCUS_NAMES } from '../../constants';

export default ({ fileUploadRef, parentPresenter, order, payload, isPayloadCreator }) => {
  const popover = usePopover();

  const source = useAsObservableSource({
    payload,
    order,
    isPayloadCreator,
    isOpened: popover.isOpened,
  });

  const presenter = useLocalStore(() => ({
    openSelectLocation() {
      Tasks.app.openPopup(SelectLocationPopup, {
        params: { onSelect: parentPresenter.setLocationPayload },
      });
    },

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      fileUploadRef.current && fileUploadRef.current.open();
      presenter.togglePopover();
    },

    get items() {
      return [
        {
          key: 'document',
          IconComponent: IcDocumentStrokeIcon,
          onClick: presenter.onClick,
        },
        {
          key: 'location',
          IconComponent: IcLocationStrokeIcon,
          onClick: presenter.openSelectLocation,
        },
      ];
    },

    get isShow() {
      if (
        source.isPayloadCreator &&
        parentPresenter.actualFocusPosition === FOCUS_NAMES.CREATOR_PAYLOAD &&
        source.payload.text === ''
      ) {
        return true;
      }

      return parentPresenter.actualFocusPosition === source.order && source.payload.text === '';
    },

    togglePopover() {
      parentPresenter.showPlaceholder = source.isOpened;
      popover.toggle();
    },
  }));

  return { presenter, popover };
};
